import { useState } from 'react'
import RoutesMap from 'route_control/RouteControl'
import { Bell, Globe, KeyRound, Menu, Search, UserPen } from 'lucide-react'
import { Dropdown } from 'antd'
import { ChangePassword } from 'pages/user'
import img_nf from '../../assets/images/default.jpg'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { toggleChangePasswordModal } from '../../redux/slices/globalSlice'
import { SessionManager, getConfig } from 'utils'
import { useTranslation } from 'react-i18next'

export default function Header(props) {

    const { collapsed, setCollapsed, drawerOpen, setDrawerOpen, isMobileOrTablet } = props
    const [date, setDate] = useState(new Date().toDateString())
    const { t, i18n } = useTranslation()
    const navigate = useNavigate()
    const dispatch = useDispatch()

    let cookieUser = SessionManager.getCookie("user");
    let user_details = cookieUser ? JSON.parse(cookieUser) : null;
    // console.log(user_details)

    const lang_option = {
        items: [
            { key: 'en', label: 'English' },
        ],
        selectable: true,
        defaultSelectedKeys: [i18n?.language],
        onClick: ({ key }) => {
            i18n.changeLanguage(key)
        },
    };

    const settings_option = [
        {
            key: '1',
            label: 'Profile',
            icon: <UserPen size={16} />,
            onClick: () => navigate('/profile')
        },
        {
            key: '2',
            label: 'Change Password',
            icon: <KeyRound size={16} />,
            onClick: () => changePasswordModal()
        },
    ];

    const changePasswordModal = () => dispatch(toggleChangePasswordModal())

    return (
        <>
            <nav className={`navbar fixed-top ${isMobileOrTablet ? 'navbar_mobile_view' : collapsed ? "navbar_body_collapsed" : "navbar_body_notcollapsed"}`} >
                <div className="container-fluid">
                    <span className="navbar-brand d-flex align-items-center">
                        <Menu size={20} onClick={() => isMobileOrTablet ? setDrawerOpen(!drawerOpen) : setCollapsed(!collapsed)} style={{ cursor: 'pointer' }} />
                        <span className='d-flex flex-column ms-3'>
                            <span style={{ fontSize: '13px' }} className="fw-bold">Welcome, {user_details ? `${user_details?.user_first_name || ""} ${user_details?.user_last_name || ""}` : "Guest"}! ({user_details?.roleInfo?.role_name || "-"})</span>
                            <span style={{ fontSize: '11px' }} className='text-secondary'>{date}</span>
                        </span>
                    </span>

                    <div className='d-flex align-items-center header-actions'>

                        <div className="header-search">
                            <Search size={18} className="header-search__icon" aria-hidden />
                            <input
                                type="text"
                                className="header-search__input"
                                placeholder=""
                            />
                        </div>

                        <Dropdown
                            menu={lang_option}
                            placement="bottom"
                        >
                            <Globe size={18} style={{ cursor: 'pointer' }} />
                        </Dropdown>

                        <span>|</span>

                        <button
                            type="button"
                            className="header-notification-btn"
                            onClick={() => navigate(RoutesMap.NOTIFICATIONS.path)}
                        >
                            <Bell size={18} />
                        </button>

                        <span>|</span>

                        <Dropdown
                            menu={{ items: settings_option }}
                            placement="bottom"
                        >
                            <img
                                src={user_details?.user_profile && getConfig.BASE_URL + user_details?.user_profile || img_nf}
                                alt="admin"
                                className='img-fluid header_profile_img'
                                style={{ cursor: 'pointer' }}
                                onError={(e) => { e.target.onerror = null; e.target.src = img_nf }}
                            />
                        </Dropdown>
                    </div>
                </div>
            </nav>

            <ChangePassword />
        </>
    )
}